module.exports = __webpack_public_path__ + "static/media/fowclearer.f3dede5d.frag";